import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OtherService } from 'src/app/services/other.service';
import { BusyService } from 'src/app/services/busy.service';
import { AccountService } from 'src/app/services/account.service';
import Swal from 'sweetalert2';
import axios from "src/app/services/axios";
import * as moment from 'moment-jalaali';
import { MapService } from 'src/app/services/map.service';

declare let $: any;

@Component({

  selector: 'app-partner-dashboard',

  templateUrl: './partner-dashboard.component.html',

  styleUrls: ['./partner-dashboard.component.css']

})

export class PartnerDashboardComponent implements OnInit {

  passwordStrength = '';

  passwordStrengthMessage = '';

  lst_City: any = [];

  lst_GroupCar: any = [];

  lst_Menu = [

    { strTitle: 'ثبت درخواست سفر', strImage: '../../../../assets/imgs/new-employee.png', routerLink: '/partners/dashboard', iAction: 2 },

    { strTitle: 'سفرهای من', strImage: '../../../../assets/imgs/road-trip.png', routerLink: '/partners/my-trips' },

    { strTitle: 'گزارش مالی', strImage: '../../../../assets/imgs/analysis.png', routerLink: '/partners/financial-report' },

    { strTitle: 'تغییر رمز عبور', strImage: '../../../../assets/imgs/reset-password.png', routerLink: '/partners/dashboard', iAction: 3 },

    { strTitle: 'خروج', strImage: '../../../../assets/imgs/logout.png', routerLink: '/partners/dashboard', iAction: 1 },

  ]

  isCity: boolean = false;

  showCustom_Map: boolean = false;

  showFilter: boolean = false;

  bEditMode: boolean | 'showMode' | 'searchMode' = false;

  hasUpperCase = false;

  hasLowerCase = false;

  hasNumbers = false;

  hasSpecialChars = false;

  isLongEnough = false;

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this._otherService.get_PartnerData().iSystemUser),
    strSession: new FormControl(this._otherService.get_PartnerData().strSession),
    strName: new FormControl(''), //  نام مسافر
    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 
    strMobile: new FormControl('', Validators.required), //  موبایل مسافر
    tiSex: new FormControl(1), //  جنسیت 
    strDate: new FormControl('', Validators.required), //  تاریخ سفر
    strTime: new FormControl(moment().format("HH:mm"), Validators.required), //  ساعت سفر
    strSCity: new FormControl('', Validators.required), //  شهر مبدا
    fSLon: new FormControl('', Validators.required),
    fSLat: new FormControl('', Validators.required),
    strSAddress: new FormControl('', Validators.required),
    strDCity: new FormControl('', Validators.required), //  شهر مقصد
    fDLon: new FormControl('0'),
    fDLat: new FormControl('0'),
    strDAddress: new FormControl(''),
    bCameBack: new FormControl(false), //  دارای برگشت 
    bHasStop: new FormControl(false), //  داری توقف
    fEstimateStop: new FormControl(''), //  مدت توقف مثلا 3.5 ساعت 
    tiPassenger: new FormControl(1), //  تعداد مسافر
    bCargo: new FormControl(false), //  بار دارد
    strCargoDetail: new FormControl(''), //  توضیحات بار
    bPet: new FormControl(false), //  حیوان خانگی 
    bSmoking: new FormControl(false), //  سیگار مجاز
    bNeedHelp: new FormControl(false), //  نیاز به کمک 
    bInvoiceRequired: new FormControl(false), //  نیاز به فاکتور
    strCompany: new FormControl(''), //  اسم شرکت برای فاکتور
    bForeigner: new FormControl(false), //  مسافر غیر ایرانی
    bHiddenFare: new FormControl(false), //  مسافر غیر ایرانی
    strPassportNumber: new FormControl(''), //  شماره پاسپورت مسافر غیر ایرانی 
    strComment: new FormControl(''), //  توضیحات
    tiMobileGroup: new FormControl('', Validators.required), //  گروه خودرویی
    iEstimateRent: new FormControl({ value: 0 }, Validators.required), // کرایه
    iPartnerRent: new FormControl(0, Validators.required), //  کرایه اعلام شده
    iPartnerReceived: new FormControl(0, Validators.required), //  کرایه دریافت شده
    fEstimateKm: new FormControl(''), //  مسافت
    _fKm: new FormControl(''), //  مسافت
    _strTime: new FormControl(''), //  مدت زمان سفر
    iDiscount: new FormControl('0'),
    // _index: new FormControl('-1')
    // iEstimateRent: new FormControl(0, Validators.required), //  کرایه
    // strUnitID: new FormControl(''), // شناسه خودرو
    // strDriver_FullName: new FormControl(''), // نام راننده
    // strDriver_Mobile: new FormControl(''), // موبایل راننده
    // strID: new FormControl(''), //  کد ملی
    // bForAnother: new FormControl(false), //  برای دیگری
    // strPassengersName: new FormControl(''), //  نام مسافر دیگر

  })

  mdl_Map: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  })

  mdl_PW: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this._otherService.get_PartnerData().iSystemUser),

    strSession: new FormControl(this._otherService.get_PartnerData().strSession),

    currentPassword: ['', Validators.required],

    newPassword: ['', [Validators.required, Validators.minLength(4)]],

    confirmPassword: ['', Validators.required]

  })

  constructor(

    private _router: Router,

    private _route: ActivatedRoute,

    private FormBuilder: FormBuilder,

    private _otherService: OtherService,

    public loaderService: BusyService,

    private _service: AccountService,

    private _MapService: MapService,


  ) { }

  ngOnInit(): void {

    this._otherService.setTitle('تاکسی لون | پنل همکاران');

    this.city_TaxiLon()

  }

  ngOnDestroy() {

    // this._otherService.setTitle('');

    $("#PW_Modal").modal("hide");

    $("#newReq_Modal").modal("hide");

    $("#map_Modal").modal("hide");

    this.showCustom_Map = false;

  }

  showAction(iAction: 1 | 2) {

    if (iAction == 1) {

      Swal.fire({

        title: "آیا قصد خروج از حساب کاربری خود را دارید؟",

        icon: 'warning',

        iconHtml: '?',

        showCancelButton: true,

        showConfirmButton: true,

        reverseButtons: true,

        confirmButtonColor: '#10b981',

        cancelButtonColor: '#EF4444',

        confirmButtonText: 'تایید',

        cancelButtonText: 'لغو',

      }).then((result) => {

        if (result.isConfirmed) {

          window.localStorage.removeItem('db31a17f18d1a8a3l0ifrEz8abJb02');

          this._router.navigateByUrl('/partners');

        }

      })

    }

    else if (iAction == 2) {

      this.mdl_Request.patchValue({
        strName: '', //  نام مسافر
        strFamily: '', //  فامیل مسافر 
        strMobile: '', //  موبایل مسافر
        tiSex: 1, //  جنسیت 
        strDate: moment().format("jYYYY/jMM/jDD"), //  تاریخ سفر
        strTime: moment().format("HH:mm"), //  ساعت سفر
        strSCity: '', //  شهر مبدا
        fSLon: '',
        fSLat: '',
        strSAddress: '',
        strDCity: '', //  شهر مقصد
        fDLon: 0,
        fDLat: 0,
        strDAddress: '',
        bCameBack: false, //  دارای برگشت 
        bHasStop: false, //  داری توقف
        fEstimateStop: '', //  مدت توقف مثلا 3.5 ساعت 
        tiPassenger: 1, //  تعداد مسافر
        bCargo: false, //  بار دارد
        strCargoDetail: '', //  توضیحات بار
        bPet: false, //  حیوان خانگی 
        bSmoking: false, //  سیگار مجاز
        bNeedHelp: false, //  نیاز به کمک 
        bInvoiceRequired: false, //  نیاز به فاکتور
        bHiddenFare: false, //  نیاز به فاکتور
        strCompany: '', //  اسم شرکت برای فاکتور
        bForeigner: false, //  مسافر غیر ایرانی
        strPassportNumber: '', //  شماره پاسپورت مسافر غیر ایرانی 
        strComment: '', //  توضیحات
        tiMobileGroup: '', //  گروه خودرویی
        iEstimateRent: 0, // کرایه
        iPartnerRent: 0, //  کرایه اعلام شده
        iPartnerReceived: 0, //  کرایه دریافت شده
        fEstimateKm: '', //  مسافت
        _fKm: '', //  مسافت
        _strTime: '', //  مدت زمان سفر
        iDiscount: '0'

      })

      $("#newReq_Modal").modal("show");

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

    else if (iAction == 3) {

      $("#PW_Modal").modal("show");


    }

  }

  city_TaxiLon = async () => {

    if (!this._service.list_StoredCity.length) {

      this.loaderService.busy();

      let res = JSON.parse((await axios.post(`TaxiLon_City_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data);

      if (res.bError || res.iResult == 0) {

        this.loaderService.idle();

        return this._service.toastSwal('error', res.strError);

      }

      this.lst_City = res;

      this._service.list_StoredCity = res;

    }

    else {

      this.lst_City = this._service.list_StoredCity;

    }

    // ------------------------------------------------------------- >

    if (!this._service.list_StoredCategory.length) {

      const resp = await axios.post(`GetMobileGroup`, {});

      resp.data = JSON.parse(resp.data);

      this.loaderService.idle();

      if (resp.data.bError || resp.data.iResult == 0) return this._service.toastSwal('error', resp.data.strError);

      this.lst_GroupCar = resp.data;

      this._service.list_StoredCategory = this.lst_GroupCar;

    }

    else {

      this.lst_GroupCar = this._service.list_StoredCategory;

    }


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  setValue_Filter(event: any, strKey: string) {

    if (this.isCity) return // اگر سفر شهری بود شهر را تغییر نده

    if (event?.strCityName) {

      if (strKey == 'strSCity') {

        this.mdl_Request.patchValue({

          strSCity: event.strCity,

          fSLon: event.fLon,

          fSLat: event.fLat,

        })

      }

      else {

        this.mdl_Request.patchValue({

          strDCity: event.strCity,

          fDLon: event.fLon,

          fDLat: event.fLat,

        })

      }

    }

    else {

      if (strKey == 'strSCity') {

        this.mdl_Request.patchValue({

          strSCity: '',

          fSLon: '',

          fSLat: '',

        })

      }

      else {

        this.mdl_Request.patchValue({

          strDCity: '',

          fDLon: '',

          fDLat: '',

        })

      }

    }

  }

  show_Map(mdl_Type: 'strSAddress' | 'strDAddress') {

    if (mdl_Type == 'strSAddress') {

      if (this.mdl_Request.get('strSCity')?.value.trim() == '') return this._service.toastSwal('error', 'شهر مبداء را انتخاب کنید');

      if (this.mdl_Request.get('strSAddress')?.value.trim() == '') {

        this._MapService.getCurrentLocation().then(coords => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_Request.get('strSAddress')?.value,

            fLon: coords.longitude,

            fLat: coords.latitude,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

        }).catch(error => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_Request.get('strSAddress')?.value,

            fLon: this.mdl_Request.get('fSLon')?.value,

            fLat: this.mdl_Request.get('fSLat')?.value,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

          console.error('Error getting location:', error);

        });


      }

      else {

        let cityName = this.returnStrValue('strCity', this.mdl_Request.get('strSCity')?.value, this.lst_City, 'strCityName');

        let address = !this.mdl_Request.get('strSAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_Request.get('strSAddress')?.value : this.mdl_Request.get('strSAddress')?.value;

        this.mdl_Map.patchValue({

          strAddress: address,

          fLon: this.mdl_Request.get('fSLon')?.value,

          fLat: this.mdl_Request.get('fSLat')?.value,

          strSource: 'strSAddress',

        });

        this.showCustom_Map = true;


      }

    }

    else {

      let cityName = this.returnStrValue('strCity', this.mdl_Request.get('strDCity')?.value, this.lst_City, 'strCityName');

      let address = !this.mdl_Request.get('strDAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_Request.get('strDAddress')?.value : this.mdl_Request.get('strDAddress')?.value;

      this.mdl_Map.patchValue({

        strAddress: address,

        fLon: this.mdl_Request.get('fDLon')?.value,

        fLat: this.mdl_Request.get('fDLat')?.value,

        strSource: 'strDAddress'

      })

      this.showCustom_Map = true;

    }

  }

  submitMap(event: any) {

    this.showCustom_Map = false;

    if (this.mdl_Map.get('strSource')?.value == 'strSAddress') {

      if (event.strText != '') {

        this.mdl_Request.patchValue({

          strSAddress: event.strText,

          fSLon: event.longitude,

          fSLat: event.latitude,

        })

      }

      else {

        this.mdl_Request.patchValue({

          strSAddress: '',

          fSLon: '',

          fSLat: '',

        })

      }

    }

    else {

      if (event.strText != '') {

        this.mdl_Request.patchValue({

          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,

        })

      }

      else {

        this.mdl_Request.patchValue({

          strDAddress: '',

          fDLon: '',

          fDLat: '',

        })

      }

    }

  }

  reset_calc() {

    this.mdl_Request.patchValue({

      iEstimateRent: 0,

      _fKm: '',

      _strTime: ''

    })

  }

  putSeparator(number: number | string, mode: 'showMode' | 'searchMode' | boolean): string | number {

    if (mode == 'showMode' || mode) {

      return number.toLocaleString();

    }

    else {
      return number
    }

  }

  calc_Renting = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_Request.value);

    if (this.isCity ? this.calcValidity() : (model.tiMobileGroup == '' || model.strSCity == '' || model.strDCity == '')) return this._service.toastSwal('error', 'لطفا فرم را با دقت تکمیل کنید');

    this.loaderService.busy();

    let res = JSON.parse((await axios.post(`TaxiLon_ORG_TravelCostEstimate`, model)).data);

    this.loaderService.idle();

    this.mdl_Request.patchValue({

      iEstimateRent: res.iRent.toLocaleString(),

      iPartnerRent: 0,

      iPartnerReceived: 0,

      fEstimateKm: res.fKm,

      _fKm: res.fKm.toLocaleString() + ' کیلومتر ',

      _strTime: res.strTime,

      iDiscount: res.iDiscount

    })

  }

  calcValidity() {

    const requiredFields = [

      { key: "fSLon", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "fSLat", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "strSAddress", isValid: (value: any) => value !== '' },

      { key: "strDCity", isValid: (value: any) => value !== '' },

      { key: "tiMobileGroup", isValid: (value: any) => value !== '' },

    ];

    return requiredFields.some(field => !field.isValid(this.mdl_Request.value[field.key]));

  }

  search_ByMobile = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_Request.value);

    if (model.strMobile == '' || model.strMobile.length != 11) return this._service.toastSwal('error', 'شماره موبایل را به درستی وارد کنید');

    this.loaderService.busy();

    let res = JSON.parse((await axios.post(`TaxiLon_User_Info4Manager`, model)).data);

    this.loaderService.idle();

    this.bEditMode = 'searchMode';

    setTimeout(() => {

      this.bEditMode = false;

    }, 1000);

    if (res.bError || res.iResult == 0) return this._service.toastSwal('error', res.strError);

    if (res.length) {

      this.mdl_Request.patchValue({

        strName: res[0].strName, //  نام مسافر

        strFamily: res[0].strFamily, //  فامیل مسافر 

        tiSex: res[0].tiSex, //  جنسیت 

        strID: res[0].strID, //  کد ملی

        strSCity: res[0].strCity, //  شهر مبدا

        fSLon: res[0].fLat > 0 ? res[0].fLat : this.get_latLong(res[0].strCity, 'fLat'),

        fSLat: res[0].fLon > 0 ? res[0].fLon : this.get_latLong(res[0].strCity, 'fLon'),

        strSAddress: res[0].strAddress,

      })

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

    else {

      this.mdl_Request.patchValue({

        strName: '', //  نام مسافر

        strFamily: '', //  فامیل مسافر 

        tiSex: '', //  جنسیت 

        strID: '', //  کد ملی

        strSCity: '', //  شهر مبدا

        fSLon: '',

        fSLat: '',

        strSAddress: '',

      })

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

  }

  get_latLong(strCity: number | string, target: 'fLon' | 'fLat'): number {

    return this.lst_City.filter((el: any) => { return el.strCity == strCity })[0][target];

  }

  submit_Request = async () => {

    if (this.mdl_Request.invalid) return this._service.toastSwal('error', 'لطفا موارد ستاره دار را وارد کنید');

    if (this.mdl_Request.get('strDate')?.value < moment().format("jYYYY/jMM/jDD")) {

      return this._service.toastSwal('error', 'تاریخ سفر نمی تواند گذشته باشد')

    }

    if (this.mdl_Request.get('iPartnerRent')?.value < this.mdl_Request.get('iEstimateRent')?.value) {

      return this._service.toastSwal('error', 'کرایه اعلام شده، کمتر از کرایه سفر می باشد')

    }

    if (this.mdl_Request.get('iPartnerReceived')?.value > this.mdl_Request.get('iPartnerRent')?.value) {

      return this._service.toastSwal('error', 'مبلغ دریافتی، بیشتر از کرایه اعلامی می باشد')

    }

    if (this.mdl_Request.get('bCargo')?.value && this.mdl_Request.get('strCargoDetail')?.value.trim() == '') {

      return this._service.toastSwal('error', 'توضیحات با را وارد کنید')

    }

    if (this.mdl_Request.get('bHasStop')?.value && (this.mdl_Request.get('fEstimateStop')?.value.trim() == '' || this.mdl_Request.get('fEstimateStop')?.value <= 0)) {

      return this._service.toastSwal('error', 'مدت توقف را مشخص کنید')

    }

    if (this.mdl_Request.get('bInvoiceRequired')?.value && this.mdl_Request.get('strCompany')?.value.trim() == '') {

      return this._service.toastSwal('error', 'جهت صدور فاکتور نام شرکت مورد نظر را وارد کنید')

    }

    if (this.mdl_Request.get('bForeigner')?.value && this.mdl_Request.get('strPassportNumber')?.value.trim() == '') {

      return this._service.toastSwal('error', 'شماره پاسپورت مسافر غیر ایرانی را وارد کنید')

    }

    if (this.mdl_Request.get('bForAnother')?.value && this.mdl_Request.get('strPassengersName')?.value.trim() == '') {

      return this._service.toastSwal('error', 'نام متقاضی را وارد کنید')

    }

    else {

      if (this.mdl_Request.get('iEstimateRent')?.value.toString().includes(',')) {

        this.mdl_Request.patchValue({

          iEstimateRent: this.mdl_Request.get('iEstimateRent')?.value.replace(/,/g, '')

        })

      }

      if (this.mdl_Request.get('iPartnerRent')?.value.toString().includes(',')) {

        this.mdl_Request.patchValue({

          iPartnerRent: this.mdl_Request.get('iPartnerRent')?.value.replace(/,/g, '')

        })

      }

      if (this.mdl_Request.get('iPartnerReceived')?.value.toString().includes(',')) {

        this.mdl_Request.patchValue({

          iPartnerReceived: this.mdl_Request.get('iPartnerReceived')?.value.replace(/,/g, '')

        })

      }

      if (!this.bEditMode) {

        Swal.fire({

          title: 'آیا از ثبت سفر اطمینان دارید ؟',

          icon: 'warning',

          iconHtml: '?',

          showCancelButton: true,

          showConfirmButton: true,

          reverseButtons: true,

          confirmButtonColor: '#177F4F',

          confirmButtonText: 'تایید',

          cancelButtonText: 'لغو',

        }).then(async (result) => {

          if (result.isConfirmed) {

            this.loaderService.busy()

            let res = JSON.parse((await axios.post(`TaxiLon_Trip_Partner_Save`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data);

            this.loaderService.idle();

            if (res.iResult == 0 || res.iResult == -1) return this._service.toastSwal('error', res.strError)

            $("#newReq_Modal").modal("hide");

            Swal.fire({

              title: `.سفر با کد رهگیری <span class="text-danger"> ${res[0].iTaxiLon_Trip} </span> با موفقیت ثبت شد`,

              icon: 'success',

              iconHtml: '',

              showCancelButton: false,

              showConfirmButton: true,

              reverseButtons: true,

              confirmButtonColor: '#6c757d',

              confirmButtonText: 'تایید',

            })

          }

        })


      }

    }

  }

  checkPasswordStrength() {

    const password = this.mdl_PW.get('newPassword')?.value || '';

    this.hasUpperCase = /[A-Z]/.test(password);

    this.hasLowerCase = /[a-z]/.test(password);

    this.hasNumbers = /\d/.test(password);

    this.hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    this.isLongEnough = password.length >= 8;

    const strengthScore = (this.hasUpperCase ? 1 : 0) + (this.hasLowerCase ? 1 : 0) + (this.hasNumbers ? 1 : 0) + (this.hasSpecialChars ? 1 : 0) + (this.isLongEnough ? 1 : 0);

    if (strengthScore <= 2) {

      this.passwordStrength = 'weak';

      this.passwordStrengthMessage = 'رمز عبور ضعیف است (طولانی‌ تر و پیچیده‌ تر کنید)';

    }

    else if (strengthScore === 3) {

      this.passwordStrength = 'medium';

      this.passwordStrengthMessage = 'رمز عبور متوسط است (بهبود دهید)';

    }

    else if (strengthScore === 4) {

      this.passwordStrength = 'strong';

      this.passwordStrengthMessage = 'رمز عبور قوی است';

    }

    else if (strengthScore === 5) {

      this.passwordStrength = 'very-strong';

      this.passwordStrengthMessage = 'رمز عبور بسیار قوی است';

    }

  }

  submit_Password = async () => {

    if (!this.mdl_PW.get('newPassword').valid) return this._service.toastSwal('error', 'طول رمز عبور جدید باید بیشتر از 4 باشد');

    if (this.mdl_PW.invalid) return this._service.toastSwal('error', 'موارد ستاره دار را وارد کنید');

    if (this.mdl_PW.get('newPassword')?.value != this.mdl_PW.get('confirmPassword')?.value) return this._service.toastSwal('error', 'رمز عبور و تکرار رمز عبور مطابقت ندارند');

    else {

      let model = {

        iSystemUser: this._otherService.get_PartnerData().iSystemUser,

        strSession: this._otherService.get_PartnerData().strSession,

        strOldPassword: this.mdl_PW.get('currentPassword')?.value,

        strNewPassword: this.mdl_PW.get('newPassword')?.value

      }

      this.loaderService.busy();

      let res = JSON.parse((await axios.post(`TaxiLon_Trip_Partner_ChangePassword`, model)).data);

      this.loaderService.idle();

      if (res.bError || res.iResult == 0) return this._service.toastSwal('error', res.strError);

      $("#PW_Modal").modal("hide");

      this._service.toastSwal('success', 'تغییر رمز عبور با موفقیت انجام شد')


    }


  }


}
